import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'
import { TextExpressionContainerProps } from './TextExpressionContainer.types'
import {
  StyledSkeletonDots,
  StyledText,
  StyledToolkitText
} from './TextExpressionContainer.style'
import { useSiteState } from 'siteState/shared'
import { SkeletonDots } from '@yes.technology/react-toolkit'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import React from 'react'

const TextExpressionContainer = ({ props }: TextExpressionContainerProps) => {
  const { des, variant, styleMap } = props
  const styleProps = useStyleMaps(styleMap)

  const [allResultsFetched] = useSiteState('allResultsFetched')
  const isLoading = !allResultsFetched

  const TextComponent: React.ComponentType<
    React.ComponentProps<typeof StyledToolkitText>
  > = variant ? StyledToolkitText : StyledText
  const textProps = variant ? { variant } : {}

  return (
    <div style={styleProps}>
      {isLoading ? (
        <StyledSkeletonDots>
          <SkeletonDots />
        </StyledSkeletonDots>
      ) : (
        <TextComponent {...textProps}>
          <SafeHtmlContent html={des} />
        </TextComponent>
      )}
    </div>
  )
}

export default TextExpressionContainer
